import React from "react";
import Heading from "../../components/common/Typography/Heading";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";
import SpecialText from "../../components/common/Typography/SpecialText";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../Public/shared/publicLayoutSpec";

const TradesPosterBasicsDocs = () => {
  return (
    <div
      className={`tp-container-small mx-auto w-full text-offblack ${publicMainHeaderOffsetClass()}`}
    >
      <Heading variant={"h1"} className="flex justify-center text-center text-offblack">
        Trades Poster Basics
      </Heading>
      <div className={`${PUBLIC_HEADING_TO_CONTENT_CLASS} text-center`}>
        <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack"}>
          A Summary of Platform Use, Conduct, and Policy
        </SecondaryHeading>
      </div>
      <div className={PUBLIC_HEADING_TO_CONTENT_CLASS}>
        <SecondaryHeading variant={"MainParagraphHeading"}>
          Trades Poster Basics
        </SecondaryHeading>
      </div>
      <div className="mt-1">
        <SpecialText variant={"DateStamp"}>
          Last updated: January 2025
        </SpecialText>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Please read these platform basics carefully before using Our Service.
        </Paragraph>
      </div>
      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          1. Community Guidelines
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Trades Poster is a platform built for professional trade services. Users are expected to act respectfully, follow Australian laws, and use the platform as intended. Misuse may result in restricted access or removal.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          2. Account Suspension
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Accounts may be suspended or removed due to false information, misconduct, repeated policy breaches, or misuse of features. All suspensions are handled case by case, with or without notice.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          3. Reporting & Blocking
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Users can report posts, messages, or profiles for review. Blocking tools are available to prevent unwanted contact. All reports are reviewed by our team and actioned where appropriate.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          4. Badge & Licensing
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Businesses may submit licences, ABNs, and ID for verification. Trades Poster reviews these documents to the best of its ability but does not guarantee their validity. Customers must verify all business details directly before starting work. Businesses must provide credentials when asked.
          <br /><br />
          Verification documents are held temporarily and discarded after review. Misuse of this process may result in account action.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          5. Security & Data
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          All data is stored using Microsoft services within Australian borders. Sensitive ID documents are not kept after verification. Trades Poster does not use customer or business data for marketing or third-party purposes. The platform is not liable for unauthorised use of data outside its control.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          6. Content & Copyright
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          All uploaded content must be original or legally owned. Misleading, copied, or fake material may be removed. Users are responsible for the accuracy of their listings, profiles, and portfolios.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          7. Platform Use
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Trades Poster does not control payments, job outcomes, or customer agreements. All engagements are between the customer and business. Platform tools are provided as-is. Misuse or abuse may result in removal.
        </Paragraph>
      </div>

      <div className="mt-10">
        <SecondaryHeading variant={"MainParagraphHeading"}>
          Disclaimer
        </SecondaryHeading>
      </div>
      <div className="mt-3">
        <Paragraph variant={"MainParagraph"} className="text-offblack">
          Trades Poster tries to verify all information but does not guarantee or certify any user, licence, or job. All users must exercise their own judgment and verify all details independently.
        </Paragraph>
      </div>
    </div>
  );
};

export default TradesPosterBasicsDocs;
